import React, { useState, useEffect } from 'react'
import { MiFooter } from '../../components/footer/MiFooter';
import './Calendario.css'
import { ContentBodyCalendario } from '../../components/CalendarioEmpresa/ContentBodyCalendario';
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import HeaderHome from '../../components/headerHome/HeaderHome';

export const Calendario = () => {

  const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
  const closeMenu = () => {
    if (MenuLateral === true) {
      setMenuLateral(false)
    }
  }

  return (
    <div className='UserFeedback' onClick={closeMenu} >
      <div className='headerUserFeedback'>
        <HeaderHome />
      </div>
      <div className="bodyUserFeedback">
        <ContentBodyCalendario />
      </div>
      <div className='footerReservarServicio'>
        <MiFooter />
      </div>
    </div>
  )
}
